import systemImage2 from "../../assets/images/systemImage2.png";
import "./rooms.css";
import { Link, Navigate, useNavigate } from "react-router-dom";
import AppText from "../_shared/components/AppText";
import SideMenu from "../_shared/components/SideMenu";

import GoOnIcon from "../../assets/images/icons/ambienti-freccia-home.svg";

import GoOnIcon2 from "../../assets/images/icons/ambienti-freccia-public.svg";
import { useEffect, useState, useLayoutEffect } from "react";

function Rooms(props) {
  const { setSplash } = props;
  useEffect(() => setSplash(false), []);
  let navigate = useNavigate();

  const [height, setHeight] = useState(2000);
  const [width, setWidth] = useState(2000);

  function setDimensions(img) {
    setHeight(img?.target?.offsetHeight);
    setWidth(img?.target?.offsetWidth);
  }

  return (
    <div className="rootMenu">
      <SideMenu></SideMenu>
      <div className="rootContent">
        <div
          style={{
            maxHeight: "95vh",
            aspectRatio: 16 / 9,
            position: "relative",

            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",

            backgroundImage: `url(${systemImage2})`,
          }}
        >
          {/* <img
            src={systemImage2}
            style={{
              maxHeight: "100%",
              aspectRatio: 16 / 9,
              maxWidth: "100%",
            }}
            alt=""
          ></img> */}
          {/* homeSpaces div */}
          <div
            style={{
              position: "absolute",
              maxWidth: "35%",

              top: 30,
              paddingLeft: "5%",
              cursor: "pointer",

              height: "100%",
            }}
            onClick={() => navigate(`/home-spaces`)}
          >
            <div className="row" style={{ marginBottom: 40 }}>
              <AppText xbig bold style={{ color: "#4f4a34" }}>
                home spaces
              </AppText>
              <img
                src={GoOnIcon2}
                style={styles.icon}
                alt=""
                className="animate-pulse"
              ></img>
            </div>
            <AppText style={{ color: "#4f4a34" }} bold small>
              Progettare uno spazio ottimale a misura di quotidiano, nel quale
              identificarsi e sentirsi a casa.
            </AppText>

            <AppText style={{ color: "#4f4a34" }} light small>
              Designing an optimal space tailor made to accomodate daily life, a
              space to identify with and feel at home in.
            </AppText>
          </div>
          {/* publicSpaces div */}
          <div
            style={{
              position: "absolute",
              maxWidth: "35%",

              top: 30,
              height: "100%",
              marginLeft: "55%",
              paddingRight: "5%",
              cursor: "pointer",
            }}
            onClick={() => navigate(`/public-spaces`)}
          >
            <div
              className="row"
              style={{
                position: "relative",
                marginBottom: 40,
              }}
            >
              <AppText xbig bold style={{ color: "#d69a28" }}>
                public spaces
              </AppText>
              <img
                src={GoOnIcon}
                style={styles.icon}
                alt=""
                className="animate-pulse"
              ></img>
            </div>
            <AppText style={{ color: "#d69a28" }} bold small>
              Caratterizzare l'ambiente con soluzioni modulari e flessibili
              dedicate ai moderni spazi pubblici.
            </AppText>
            <AppText style={{ color: "#d69a28" }} light small>
              Giving the interior a distintive look with modular, flexible
              solutions designed specifically for modern public spaces.
            </AppText>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  titleHome: {},
  sectionStyle: {
    maxHeight: "90vh",
    aspectRatio: 16 / 9,
    maxWidth: "90vw",
  },
  icon: {
    marginTop: 10,
    height: 20,
    width: 20,
  },
  homeSpaces: {
    paddingLeft: "5%",
    paddingRight: "5%",

    maxWidth: "40%",
    height: "85vh",
  },
};

export default Rooms;
